import { render } from "./Upload-files.vue?vue&type=template&id=7939543e&scoped=true"
import script from "./Upload-files.vue?vue&type=script&lang=js"
export * from "./Upload-files.vue?vue&type=script&lang=js"

import "./Upload-files.vue?vue&type=style&index=0&id=7939543e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7939543e"]])

export default __exports__